<template>
  <div>
    <template v-if="isSafari">
      <safari-Blocked/>
    </template>
    <template v-else>
      <div class="login-container">
        <form class="form-signin">
          <div class="text-center mb-4">
            <div class="blinki-logo-container">
              <div class="blinki-logo"></div>
            </div>
          </div>
          <nuxt />
          <div class="flex f-center f-j-center">
            <small class="mt-2 mb-3 text-center color-white">© {{year}}</small>
          </div>
        </form>
      </div>
    </template>
  </div>
</template>
<script>
  import safariBlocked from '~/components/template/modules/safari-blocked';
  export default {
    data() {
      const date = new Date();
      return {
        year: date.getFullYear()
      }
    },
    components: {
      safariBlocked,
    },
    computed: {
      isSafari() {
        let ua = navigator.userAgent.toLowerCase();
        return ua.indexOf("safari") != -1 && ua.indexOf("chrome") == -1;
      },
    }
  }
</script>
<style lang="scss">
  @import '~/assets/css/theme.scss';
  html,
  body {
    height: 100%;
  }

  .login-container {
    height: 100vh;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    padding-top: 40px;
    padding-bottom: 40px;
    background-color: $main-color;
    justify-content: center;
  }

  .blinki-logo {
    margin-bottom: 20px;
  }

  .form-signin {
    width: 100%;
    max-width: 480px;
    padding: 15px;
    margin: auto;
    color: $white-color;
  }

  .color-white {
    color: $white-color !important;
  }
</style>
